import { render, staticRenderFns } from "./best-pick.vue?vue&type=template&id=16c738a8&scoped=true"
import script from "./best-pick.vue?vue&type=script&lang=js"
export * from "./best-pick.vue?vue&type=script&lang=js"
import style0 from "./best-pick.vue?vue&type=style&index=0&id=16c738a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c738a8",
  null
  
)

export default component.exports